import React, { Component } from 'react';
// @ts-ignore
import './App.css';
import { Route, Routes, Outlet } from 'react-router-dom';
import UserMaster from './Components/Pages/UserMaster';
import RenewalForm from './Components/Pages/JobsFileUpload';
import Sidebarr from './Components/Sidebar/Sidebar';
import JobListing from './Components/Pages/JobListing';
import DashboardUI from './Components/Dashboard/DashboardPage';
import FileReUpload from './Components/Pages/FileReUpload';
import ProductionReport from './Components/Pages/MISReport/Production Report';
import FileUploadDetailsReport from './Components/Pages/MISReport/File Upload Details Report';
import OverallStatusReport from './Components/Pages/MISReport/Overall Status Report';
import AutoJobLOBMappingReport from './Components/Pages/MISReport/Auto Job LOB Mapping Report';
import AcordJsonData from './Components/Pages/MISReport/Acord Json Data';
import PivotTable from './Components/Pages/MISReport/PivotTable';
import JobGenerationErrors from './Components/Pages/MISReport/CheckListErrorLog';
import JobListingCSR from './Components/Pages/JobListingCSR';
import { ApplicationEnum, decodeJwt } from './Components/Pages/ApiCommonService';
import { UserRole } from "./Components/Pages/ApiCommonService";
import CsrDashboard from './Components/Dashboard/csrDashboard';
import JobMaintenance from './Components/Pages/JobMaintenance';
import ChecklistTemplate from './Components/Pages/ChecklistTemplate';
import CsrUploadDocument from './Components/Pages/CsrUploadDocument';
import ValidationAndSecurity from './Components/Pages/ValidationAndSecurity';
import IntroduceBrokerWrapper from './Components/Pages/IntroduceBrokerWrapper';
import ForgotPassword from './LoginConfig/ForgotPassword';
import { fetchMenuControls } from './Components/ApiSevices/UserMasterApis';
import { useLocation } from 'react-router-dom';
import { getAdminAccessforUser } from './Components/ApiSevices/JobListingApis';
import QuestionConfigMaster from './Components/Pages/QuestionConfigMaster';
import BrokerQCRefrenceMapping from './Components/Pages/BrokerQCRefrenceMapping';
import MenuControls from './Components/Pages/MenuControls';
import { assignMenusForRole } from './Components/ApiSevices/UserMasterApis';
import DefaultRoute from './Components/Routes/DefaultRoute';
import { fetchBrokerLogoById } from './Components/ApiSevices/ExdionAdminApi';
import GenerateAmsUrl from './Components/Pages/GenerateAmsUrl';
import AppSwitch from './Components/Pages/AppSwitch';
import { AppBar, Toolbar, Tooltip, IconButton, Typography, Box, Avatar, Menu, MenuItem, Divider, createTheme, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material';
import {
  MenuOpen as MenuOpenIcon,
  Logout as LogoutIcon,
} from '@mui/icons-material';
import { authContext, logout } from './LoginConfig/AdalConfig';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import QcDashboardUI from './Components/Pages/QcComponents/QcDashboardPage';
import QcProductionReport from './Components/Pages/QcComponents/Qc Production Report';
import QcFileUploadDetailsReport from './Components/Pages/QcComponents/Qc File Upload Details Report';
import QcOverallStatusReport from './Components/Pages/QcComponents/Qc Overall Status Report';
import QcJobListing from './Components/Pages/QcComponents/QcJobListing';
import QcJobListingCSR from './Components/Pages/QcComponents/JobListingCSR';
import QuoteCompareUploadDocument from './Components/Pages/QcComponents/QuoteCompareUploadDocument';
import AutoDispatcher from './Components/Pages/AutoDispatcherComponents/AutoDispatcher';
import QuoteDefaultRoute from './Components/Routes/QuoteDefaultRoute';
import { GetBrokerApplicationsById } from './Components/ApiSevices/QuoteCompareAPI';
import StpMaster from './Components/Pages/StpMaster';
import QcConfig from './Components/Pages/QcConfig';
import { SemanticConfig } from './Components/Pages/Semantic/SemanticConfig';
import UserAccess from './Components/Pages/UserAccess';
import QuestionMaster from './Components/Pages/QuestionMaster/QuestionMaster';
import LobSplitConfig from './Components/Pages/LobSplitConfig/LobSplitConfig';
import QcUserAccess from './Components/Pages/QcComponents/QcUserAccess';
import QcQuestionConfig from './Components/Pages/QcComponents/Qc Question Config';

interface MenuAccess {
  menuKey: string;
  roleId: number;
}
interface AppState {
  displaysidebar: boolean;
  decodedTokenJson: any;
  RoleId: any;
  roleId: any;
  userName: any;
  allowedMenus: any[];
  assignedMenus: any;
  loading: boolean;
  logoForBroker: any;
  darkMode: boolean;
  anchor: any;
  showProfileModal: boolean;
  authUser: any;
  basePath: string;
  apps: any[];
}

interface AppProps {
  isLoading: any;
  isAuthenticated: any;
  token: any
}

const JobListingWrapper = ({ displaysidebar }: { displaysidebar: boolean }) => {
  const location = useLocation();
  return <JobListing displaysidebar={displaysidebar} location={location} />;
};
const QcJobListingWrapper = ({ displaysidebar }: { displaysidebar: boolean }) => {
  const location = useLocation();
  return <QcJobListing displaysidebar={displaysidebar} location={location} />;
};

const JobListingcsrWrapper = ({ displaysidebar }: { displaysidebar: boolean }) => {
  const location = useLocation();
  return <JobListingCSR displaysidebar={displaysidebar} location={location} />;
};

const QcJobListingcsrWrapper = ({ displaysidebar }: { displaysidebar: boolean }) => {
  const location = useLocation();
  return <QcJobListingCSR displaysidebar={displaysidebar} location={location} />;
};

const SidebarLayout = ({
  displaysidebar,
  toggleSidebar,
  assignedMenus,
  allowedMenus,
  logoForBroker
}: {
  displaysidebar: boolean;
  toggleSidebar: () => void;
  assignedMenus: any;
  allowedMenus: any;
  logoForBroker: string | null;
}) => (
  <div>
    <Sidebarr displaysidebar={displaysidebar} toggleSidebar={toggleSidebar} assignedMenus={assignedMenus} allowedMenus={allowedMenus} logoForBroker={logoForBroker} />
    <Outlet />
  </div>
);

class App extends Component<AppProps, AppState> {
  constructor(props: AppProps) {
    super(props);
    this.state = {
      displaysidebar: window.innerWidth >= 468,
      roleId: '',
      decodedTokenJson: '',
      RoleId: null,
      userName: '',
      allowedMenus: [],
      assignedMenus: {},
      loading: true,
      logoForBroker: null,
      darkMode: false,
      anchor: null,
      showProfileModal: false,
      authUser: authContext.getCachedUser() || null,
      basePath: "",
      apps: []
    };
  }

  async componentDidMount(): Promise<void> {
    const token = sessionStorage.getItem('token');
    const basePath = window.location.pathname.split('/')[1];
    this.setState({ basePath: `/${basePath}` });
    this.fetchUserApplicationAccess();
    this.fetchExdionAdminUSer().then(() => {
      if (token) {

        const token = sessionStorage.getItem('token');
        if (token) {
          const decodedToken = decodeJwt(token);
          if (decodedToken) {
            this.setState({
              roleId: parseInt(decodedToken?.RoleId),
              authUser: {
                ...decodedToken,
                brokerId: decodedToken?.BrokerId,
                roleId: decodedToken?.RoleId,
                userName: decodedToken?.userName || decodedToken?.Email
              }
            });
          } else {
            console.warn("Token decoding failed or returned null");
          }
        }

        const decodedToken = decodeJwt(token);
        if (decodedToken) {
          this.setState({
            decodedTokenJson: decodedToken,
            RoleId: decodedToken.RoleId,
            userName: decodedToken?.userName || decodedToken?.Email,
          });

          Promise.allSettled([
            fetchBrokerLogoById(decodedToken?.BrokerId),
            assignMenusForRole(),
            fetchMenuControls(),
          ])
            .then((results) => {
              const [logoRes, assignedMenusRes, menusRes] = results;
              const logoForBroker =
                logoRes.status === "fulfilled" ? logoRes.value : null;

              const assignedMenus =
                assignedMenusRes.status === "fulfilled" ? assignedMenusRes.value : [];

              const menus =
                menusRes.status === "fulfilled" ? menusRes.value : [];

              const firstLogo = Array.isArray(logoForBroker)
                ? logoForBroker[0]
                : logoForBroker;
              this.setState({
                allowedMenus: menus,
                assignedMenus: assignedMenus,
                loading: false,
                logoForBroker: firstLogo?.BaseString || null,
              });
            })
            .catch((err) => {
              // This catch only triggers if something unexpected happens
              console.error("Unexpected error in Promise.allSettled flow:", err);
            });
        } else {
          console.warn("Token decoding failed or returned null");
        }
      }
    });
  }

  fetchUserApplicationAccess = async () => {
    try {
      this.setState({ loading: true });
      const apps = await GetBrokerApplicationsById();
      this.setState({ apps: apps });
    } catch (error) {
      console.error('Error fetching user application access:', error);
    } finally {
      this.setState({ loading: false });
    }
  }

  fetchExdionAdminUSer = async () => {
    try {
      const token: any = sessionStorage.getItem('token');
      const decodedToken = decodeJwt(token);
      if ([UserRole.QA, UserRole.Reviewer].includes(decodedToken?.RoleId)) {
        await getAdminAccessforUser(decodedToken?.Email, sessionStorage.getItem('token'));
      }
    } catch (error) {
      console.error('Error fetching brokers:', error);
    }
  };

  toggleSidebar = () => {
    this.setState((prevState) => ({
      displaysidebar: !prevState.displaysidebar,
    }));
  };

  handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    this.setState({ anchor: event.currentTarget });
  };

  handleMenuClose = () => {
    this.setState({ anchor: null });
  };

  handleProfileModalOpen = () => {
    this.setState({ showProfileModal: true, anchor: null });
  };

  handleSignOut = () => {
    this.handleMenuClose();
    logout();
  };

  handleProfileModalClose = () => {
    this.setState({ showProfileModal: false });
  };

  handleApplicationSelect = (applicationId: number) => {
    let basePath = "";

    if (applicationId === ApplicationEnum.PolicyCheck) {
      basePath = "/policyCheck";
    }

    if (applicationId === ApplicationEnum.QuoteCompare) {
      basePath = "/quote";
    }

    if (applicationId === ApplicationEnum.UserManagement) {
      basePath = "/userManagement";
    }

    // Future apps can be added here
    // if (applicationId === ApplicationEnum.AnotherApp) {
    //   basePath = "/another";
    // }

    if (basePath) {
      window.history.pushState({}, "", basePath);
      this.setState({ basePath: basePath });
      window.dispatchEvent(new PopStateEvent("popstate"));
    }
  };

  renderMenuRoutes = (assignedMenus: any, menuRouteMapping: Record<string, { path: string; element: JSX.Element }>) => {
    const { allowedMenus, userName, displaysidebar } = this.state;

    return assignedMenus?.menus?.map((menuKey: string) => {
      const menuDef = menuRouteMapping[menuKey];
      const lowerUser = userName?.toLowerCase();

      const isRestrictedMenu = ["QuestionConfig", "QuestionManagement"].includes(menuKey);
      if (isRestrictedMenu) {
        const allowedMenuEntry = allowedMenus?.find(m => m.Menu === menuKey);
        const allowedUsers = allowedMenuEntry?.UserId?.toLowerCase()?.split(',') || [];

        if (!allowedUsers.includes(lowerUser)) {
          return null;
        }
      }

      return menuDef ? (
        <Route key={menuKey} path={menuDef.path} element={menuDef.element}>
          {menuKey === "Introducebroker" && (
            <>
              <Route
                path="add"
                element={<IntroduceBrokerWrapper displaysidebar={displaysidebar} />}
              />
              <Route
                path="edit/:brokerId"
                element={<IntroduceBrokerWrapper displaysidebar={displaysidebar} />}
              />
            </>
          )}
        </Route>
      ) : null;
    });
  };

  render() {
    const { displaysidebar, RoleId, userName, decodedTokenJson, allowedMenus, assignedMenus, loading, darkMode, anchor, authUser, basePath, apps } = this.state;
    const token = sessionStorage.getItem('token');
    const User = authUser?.userName || authUser?.email;
    const usernameMap = User?.split('@')[0] || "Guest";;

    const menuRouteMapping: Record<string, { path: string; element: JSX.Element }> = {
      Dashboard: { path: "home/dashboard", element: <DashboardUI displaysidebar={this?.state?.displaysidebar} /> },
      CsrDashboard: { path: "home/csrdashboard", element: <CsrDashboard displaysidebar={this?.state?.displaysidebar} /> },
      Introducebroker: { path: "introducebroker/*", element: <IntroduceBrokerWrapper displaysidebar={this?.state?.displaysidebar} /> },
      Joblisting: { path: "jobs/joblisting", element: <JobListingWrapper displaysidebar={this?.state?.displaysidebar} /> },
      JobCsrListing: { path: "jobs/jobcsrlisting", element: <JobListingcsrWrapper displaysidebar={this?.state?.displaysidebar} /> },
      JobMaintenance: { path: "jobs/jobMaintenance", element: <JobMaintenance displaysidebar={this?.state?.displaysidebar} /> },
      Upload: { path: "jobs/upload", element: <RenewalForm displaysidebar={this?.state?.displaysidebar} basePath={this.state?.basePath} /> },
      ReUpload: { path: "jobs/reupload", element: <FileReUpload displaysidebar={this?.state?.displaysidebar} /> },
      CSRUpload: { path: "InterUpload", element: <CsrUploadDocument displaysidebar={this?.state?.displaysidebar} basePath={this.state.basePath} /> },
      Productionreport: { path: "misreport/productionreport", element: <ProductionReport displaysidebar={this?.state?.displaysidebar} /> },
      FileUploadDetailsReport: { path: "misreport/fileuploaddetailsreport", element: <FileUploadDetailsReport displaysidebar={this?.state?.displaysidebar} /> },
      OverallStatusReport: { path: "misreport/overallstatusreport", element: <OverallStatusReport displaysidebar={this?.state?.displaysidebar} /> },
      AutoJoblobmappingreport: { path: "misreport/autojoblobmappingreport", element: <AutoJobLOBMappingReport displaysidebar={this?.state?.displaysidebar} /> },
      Acordjsondata: { path: "misreport/acordjsondata", element: <AcordJsonData displaysidebar={this?.state?.displaysidebar} /> },
      Pivottablereport: { path: "misreport/pivottablereport", element: <PivotTable displaysidebar={this?.state?.displaysidebar} /> },
      Checklisterrorlog: { path: "misreport/checklisterrorlog", element: <JobGenerationErrors displaysidebar={this?.state?.displaysidebar} /> },
      MenuControl: { path: "home/MenuControl", element: <MenuControls displaysidebar={this?.state?.displaysidebar} allowedMenus={this?.state?.allowedMenus} /> },
      QuestionConfig: { path: "home/questionConfig", element: <QuestionConfigMaster displaysidebar={this?.state?.displaysidebar} /> },
      UploadChecklistTemp: { path: "UploadChecklistTemp", element: <ChecklistTemplate displaysidebar={this?.state?.displaysidebar} /> },
      ValidationSecurity: { path: "validation_security", element: <ValidationAndSecurity displaysidebar={this?.state?.displaysidebar} /> },
      QuestionManagement: { path: "home/questionConfigReference", element: <BrokerQCRefrenceMapping displaysidebar={this?.state?.displaysidebar} /> },
      GenerateAmsURL: { path: "home/GenerateAmsUrl", element: <GenerateAmsUrl displaysidebar={this?.state?.displaysidebar} /> },
      AutoDispatcher: { path: "home/AutoDispatcher", element: <AutoDispatcher displaysidebar={displaysidebar} allowedMenus={allowedMenus} /> },
      StpMaster: { path: "home/stpMaster", element: <StpMaster displaysidebar={this?.state?.displaysidebar} /> },
      QcConfig: { path: "home/QcConfig", element: <QcConfig displaysidebar={this?.state?.displaysidebar} /> },
      SemanticConfig: { path: "home/semanticConfig", element: <SemanticConfig displaysidebar={this?.state?.displaysidebar} /> },
      UserAccess: { path: "home/UserAccess", element: <UserAccess displaysidebar={this?.state?.displaysidebar} /> },
      LobSplitQuestionMaster: { path: "home/lobsplitquestionMaster", element: <QuestionMaster displaysidebar={this?.state?.displaysidebar} /> },
      LobSplitConfig: { path: "home/LobSplitConfig", element: <LobSplitConfig displaysidebar={this?.state?.displaysidebar} /> },
    };

    if (loading) {
      return <div style={{ textAlign: "left", marginLeft: "5px" }}>Loading...</div>;
    }

    const theme = createTheme({
      palette: {
        mode: darkMode ? "dark" : "light",
      },
    });

    const qcMenus: Record<string, { path: string; element: JSX.Element }> = {
      QuoteDashboard: { path: "home/dashboard", element: <QcDashboardUI displaysidebar={this?.state?.displaysidebar} /> },
      QuoteJobListing: { path: "jobs/joblisting", element: <QcJobListingWrapper displaysidebar={this?.state?.displaysidebar} /> },
      QuoteQuestionConfig: { path: "home/QcQuestionConfig", element: <QcQuestionConfig displaysidebar={this?.state?.displaysidebar} /> },
      QuoteJobCsrListing: { path: "jobs/jobcsrlisting", element: <QcJobListingcsrWrapper displaysidebar={this?.state?.displaysidebar} /> },
      QuoteProductionreport: { path: "misreport/productionreport", element: <QcProductionReport displaysidebar={this?.state?.displaysidebar} /> },
      QuoteFileUploadDetailsReport: { path: "misreport/fileuploaddetailsreport", element: <QcFileUploadDetailsReport displaysidebar={this?.state?.displaysidebar} /> },
      QuoteOverallStatusReport: { path: "misreport/overallstatusreport", element: <QcOverallStatusReport displaysidebar={this?.state?.displaysidebar} /> },
      QuoteUpload: { path: "jobs/upload", element: <QuoteCompareUploadDocument displaysidebar={this?.state?.displaysidebar} basePath={this.state?.basePath} /> },
      // QuoteUpload: { path: "jobs/upload", element: <QcRenewalForm displaysidebar={this?.state?.displaysidebar} basePath={this.state?.basePath} /> }
      QuoteUserAccess: { path: "home/QcUserAccess", element: <QcUserAccess displaysidebar={this?.state?.displaysidebar} /> },
    }

    const qcMenuList = Object.keys(qcMenus);
    const filteredQcMenus = assignedMenus?.menus?.filter((menuKey: string) => qcMenuList.includes(menuKey));
    const assignedMenusQc = { ...assignedMenus, menus: filteredQcMenus };

    const userManagementMenus: Record<string, { path: string; element: JSX.Element }> = {
      UserMaster: { path: "usermaster", element: <UserMaster displaysidebar={this?.state?.displaysidebar} /> },
    };
    const userManagementMenuList = Object.keys(userManagementMenus);
    const filteredUserManagementMenus = assignedMenus?.menus?.filter((menuKey: string) => userManagementMenuList.includes(menuKey));
    const assignedMenusUm = { ...assignedMenus, menus: filteredUserManagementMenus };

    console.log("Assigned Menus", assignedMenus);
    return (
      // <Router>
      <>
        <AppBar
          position="fixed"
          elevation={0}
          sx={{
            zIndex: (theme) => theme.zIndex.drawer + 1,
            backgroundColor: theme.palette.background.default,
            borderBottom: "1px solid #ddd",
          }}
        >
          <Toolbar>
            {window.location.pathname !== '/' &&
              <Tooltip title={displaysidebar ? "Collapse Menu" : "Expand Menu"}>
                <IconButton onClick={this.toggleSidebar} edge="start" style={{ padding: '1px', border: '1.5px solid gainsboro', borderRadius: '20px' }}>
                  {displaysidebar ? <MenuOpenIcon /> : <MenuOpenIcon />}
                </IconButton>
              </Tooltip>
            }

            {/* <Box sx={{ display: "flex", alignItems: "center", position: 'relative', top: '2px', marginLeft: '12px' }}>
                                          <img
                                              src={logoForBroker
                                                  ? `data:image/png;base64,${logoForBroker}` : `/logos/${this.getBrokerLogoName()}.png`}
                                              alt="broker-logo"
                                              onError={(e) => {
                                                  const target = e.target as HTMLImageElement;
                                                  target.onerror = null;
                                                  target.src = "/ExdionEdgeLogo.png";
                                              }}
                                              className="logo-img"
                                          />
                                      </Box> */}

            <Typography variant="h6" sx={{ position: 'relative', left: '70px', color: 'black', flexGrow: 1, margin: '10px', textAlign: "center", fontWeight: 'bold' }}>
              Welcome to Exdion
            </Typography>

            {/* Profile Icon & Menu */}
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Avatar
                alt="Profile"
                src="/profile.png"
                sx={{ cursor: "pointer" }}
                onClick={this.handleMenuOpen}
              >
                {usernameMap.charAt(0).toUpperCase()}
              </Avatar>&nbsp;&nbsp;<span
                style={{ color: 'black', fontSize: '16px', fontWeight: 'bold', cursor: 'pointer' }}
                onClick={this.handleMenuOpen}
              >
                {userName} <KeyboardArrowDownIcon sx={{ fontSize: "10px" }} />
              </span>
              <Menu
                anchorEl={anchor}
                open={Boolean(anchor)}
                onClose={this.handleMenuClose}
                PaperProps={{
                  style: {
                    borderRadius: 10,
                    boxShadow: '0px 4px 16px rgba(0,0,0,0.1)',
                    minWidth: 200
                  }
                }}
              >
                <MenuItem onClick={this.handleProfileModalOpen}>
                  <PersonOutlineIcon sx={{ marginRight: '8px' }} />
                  Profile info
                </MenuItem>
                <Divider />
                <MenuItem onClick={this.handleSignOut} sx={{ color: 'red' }}>
                  <LogoutIcon sx={{ marginRight: '8px', color: 'red' }} />
                  Sign Out
                </MenuItem>
              </Menu>
            </Box>
          </Toolbar>
        </AppBar>
        <Routes>
          {!token ? (
            <>
              {/* <Route path="/login" element={<LoginPage />} /> */}
              <Route path="/forgotpassword" element={<ForgotPassword />} />
            </>
          ) : (
            <>
              <Route
                path="/"
                element={<AppSwitch onAppSelect={this.handleApplicationSelect} allowedMenus={assignedMenus.menus} />}
              />

              {/* POLICY CHECK APPLICATION */}
              {basePath === "/policyCheck" &&
                <Route
                  path="/policyCheck/*"
                  element={
                    <SidebarLayout
                      displaysidebar={displaysidebar}
                      toggleSidebar={this.toggleSidebar}
                      assignedMenus={assignedMenus}
                      allowedMenus={allowedMenus}
                      logoForBroker={this.state.logoForBroker}
                    />
                  }
                >
                  <Route index element={<DefaultRoute roleId={assignedMenus?.roleId} />} />
                  {this.renderMenuRoutes(assignedMenus, menuRouteMapping)}
                </Route>
              }

              {/* QUOTE COMPARE APPLICATION */}
              {basePath === "/quote" && apps.includes("Quote Compare") &&
                <Route
                  path="/quote/*"
                  element={
                    <SidebarLayout
                      displaysidebar={displaysidebar}
                      toggleSidebar={this.toggleSidebar}
                      assignedMenus={assignedMenusQc}
                      allowedMenus={allowedMenus}
                      logoForBroker={this.state.logoForBroker}
                    />
                  }
                >
                  <Route index element={<QuoteDefaultRoute roleId={assignedMenusQc?.roleId} />} />
                  {this.renderMenuRoutes(assignedMenusQc, qcMenus)}
                </Route>
              }

              {/* USER MANAGEMENT APPLICATION */}
              {basePath === "/userManagement" &&
                <Route
                  path="/userManagement/*"
                  element={
                    <SidebarLayout
                      displaysidebar={displaysidebar}
                      toggleSidebar={this.toggleSidebar}
                      assignedMenus={assignedMenusUm}
                      allowedMenus={allowedMenus}
                      logoForBroker={this.state.logoForBroker}
                    />
                  }
                >
                  <Route index element={<DefaultRoute roleId={assignedMenusUm?.roleId} selectedAppId={3} />} />
                  {this.renderMenuRoutes(assignedMenusUm, userManagementMenus)}
                </Route>
              }
            </>
          )}
        </Routes>
        <Dialog
          open={this.state.showProfileModal}
          onClose={this.handleProfileModalClose}
          fullWidth
          maxWidth="sm"
          PaperProps={{
            sx: {
              borderRadius: '12px',
              backgroundColor: '#f9fafa',
              boxShadow: '0px 4px 20px rgba(0,0,0,0.1)'
            }
          }}
        >
          <DialogTitle sx={{ fontWeight: 'bold', fontSize: '20px', paddingBottom: 0 }}>
            Profile
          </DialogTitle>

          <DialogContent sx={{ paddingTop: '12px' }}>
            {/* Profile Header */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                backgroundColor: 'white',
                padding: '16px',
                borderRadius: '10px',
                marginBottom: '16px',
                boxShadow: '0px 2px 6px rgba(0,0,0,0.05)'
              }}
            >
              <Avatar
                alt="Profile"
                src="/profile.png"
                sx={{ width: 56, height: 56, marginRight: '16px' }}
              >{usernameMap.charAt(0).toUpperCase()} </Avatar>
              <Typography sx={{ fontWeight: 'bold', fontSize: '16px' }}>
                {authUser?.userName || 'Guest'}
              </Typography>
            </Box>

            {/* Personal Info Card */}
            <Box
              sx={{
                backgroundColor: 'white',
                borderRadius: '10px',
                padding: '16px',
                boxShadow: '0px 2px 6px rgba(0,0,0,0.05)'
              }}
            >
              <Typography sx={{ fontWeight: 'bold', marginBottom: '12px', fontSize: '14px' }}>
                Personal Information
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Typography variant="body2" color="text.secondary">Username</Typography>
                  <Typography variant="body1">{authUser?.userName || 'Guest'}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body2" color="text.secondary">Email</Typography>
                  <Typography variant="body1">{authUser?.Email || 'N/A'}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body2" color="text.secondary">Role</Typography>
                  <Typography variant="body1">
                    {UserRole[authUser?.roleId as keyof typeof UserRole] ?? 'N/A'}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body2" color="text.secondary">Broker ID</Typography>
                  <Typography variant="body1">{authUser?.brokerId ?? 'N/A'}</Typography>
                </Grid>
              </Grid>
            </Box>
          </DialogContent>

          <DialogActions
            sx={{
              padding: '16px',
              paddingTop: '12px',
              justifyContent: 'flex-end',
              backgroundColor: '#f9fafa'
            }}
          >
            <Button
              onClick={this.handleProfileModalClose}
              variant="contained"
              sx={{
                textTransform: 'none',
                padding: '3px 15px',
                fontSize: '14px',
                fontWeight: '500',
                borderRadius: '8px',
                backgroundColor: '#1976d2',
                '&:hover': {
                  backgroundColor: '#1565c0',
                }
              }}
            >
              Close
            </Button>
          </DialogActions>

        </Dialog>
      </>
      // </Router>
    );
  }
}

export default App;
